import React from 'react';
import './Industries.css';

const industries = [
  { icon: '🚗', name: 'Automobile' },
  { icon: '⚙️', name: 'Foundry' },
  { icon: '🏭', name: 'Manufacturing' },
  { icon: '📦', name: 'Warehousing' },
  { icon: '🚛', name: 'Logistics' },
  { icon: '🛒', name: 'Retail' },
  { icon: '📡', name: 'Telecom' },
  { icon: '🏦', name: 'Banking' },
  { icon: '🛡️', name: 'Defence' },
  { icon: '✈️', name: 'Aerospace' },
];

const Industries = () => (
  <section className="industries section-gray" id="industries">
    <div className="container">
      <div className="industries-header">
        <span className="section-label">Sectors We Serve</span>
        <h2 className="section-title">Industries We <span>Power</span></h2>
        <p className="section-desc" style={{ margin: '0 auto', textAlign: 'center' }}>
          Our workforce expertise spans the most demanding sectors of Indian industry.
        </p>
      </div>
      <div className="ind-grid">
        {industries.map((ind) => (
          <div className="ind-card" key={ind.name}>
            <div className="ind-icon">{ind.icon}</div>
            <div className="ind-name">{ind.name}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;
